/**
 * Creator Applications Mutation Hooks
 *
 * TanStack Query mutation hooks for the /become-creator flow
 */

import type { CreatorApplicationSubmitPayload } from '@/types/creator-application';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { creatorApplicationsClient } from '../client/creator-applications.client';
import { queryKeys } from '../query-keys';

export function useSubmitCreatorApplication() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreatorApplicationSubmitPayload) =>
      creatorApplicationsClient.submit(payload),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.creatorApplications.all });
      void queryClient.invalidateQueries({ queryKey: queryKeys.handler.all });
    },
  });
}
